RivalIQ.apps.Dashboard.module('mixins', function (mixins, App, Backbone, Marionette, $, _) {

    'use strict';

    mixins.UserSettingsChanged = {

        afterConstruction: function () {
            const me = this;

            me.listenTo(RivalIQ.state.view, 'reset:userSessionSettings', () => {
                if (_.get(me, ['curation', 'isTornDown'])) {
                    me.stopListening(RivalIQ.state.view, 'reset:userSessionSettings');
                    return;
                }

                me.onUserSettingsChanged();
            });

            me.listenTo(RivalIQ.state.view, 'change:userSessionSettings', () => {
                if (_.get(me, ['curation', 'isTornDown'])) {
                    me.stopListening(RivalIQ.state.view, 'change:userSessionSettings');
                    return;
                }

                me.onUserSettingsChanged();
            });

            me.listenTo(me, 'destroy', () => {
                me.stopListening(RivalIQ.state.view, 'reset:userSessionSettings');
                me.stopListening(RivalIQ.state.view, 'change:userSessionSettings');
            });
        }
    };
});
